<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <div class="fixed-parent">
      <div class="floating-buttons">
        <button class="btn btn-primary btn-icon btn-round" @click="openPhone()">
          <span class="mdi mdi-phone-classic"></span>
        </button>
        <button class="btn btn-primary btn-icon btn-round" @click="openEmail()">
          <span class="mdi mdi-email-outline"></span>
        </button>
        <button class="btn btn-primary btn-icon btn-round" @click="showOpeningHours()">
          <span class="mdi mdi-calendar-clock-outline"></span>
        </button>
      </div>
      <div class="scroll-to-top" v-show="!isScrolling && showToTopBtn">
        <button class="btn btn-primary btn-icon btn-round" @click="scrollToTop()">
          <span class="mdi mdi-arrow-up"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  data() {
    return {
      isScrolling: false,
      showToTopBtn: false,
    };
  },
  methods: {
    onScroll: function() {
      if(!this.isScrolling) {
        let top = 0
        let toBottom = 0
        if(window.pageYOffset > 0) {
          top = window.pageYOffset
          toBottom = document.body.offsetHeight - (window.innerHeight + window.pageYOffset)
        }
        this.showToTopBtn = top > 1000
      }
    },
    openPhone: function() {
      window.location = "tel:+496451718488";
    },
    openEmail: function() {
      window.location = "mailto:kontakt@blumen-twins.de";
    },
    showOpeningHours: function() {
      let scrollHeight = document.body.scrollHeight
      window.scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      })

      let interval = setInterval(() => {
        const currentScrollHeight = document.body.scrollHeight

        if(scrollHeight < currentScrollHeight) {
          scrollHeight = currentScrollHeight
          window.scrollTo({
            top: scrollHeight,
            behavior: 'smooth'
          })
        } else {
          clearInterval(interval)
        }
      }, 150)
    },
    scrollToTop: function() {
      this.isScrolling = true
      this.showToTopBtn = false
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      setTimeout(() => {
        this.isScrolling = false
      }, 1000)
    }
  }
};
</script>
<style scoped lang="scss">
.fixed-parent {
  position: fixed;
  
  left: 0;
  bottom: 0;
  
  width: 100vw;
  height: 100vh;

  z-index: 10;
  pointer-events: none;

  button {
    height: 42px;
    width: 42px;

    span {
      font-size: 20px;
      font-weight: lighter;
    }
  }

  .floating-buttons {
    position: absolute;
    right: 20px;

    pointer-events: all;

    display: flex;
    flex-direction: column;

    bottom: 50%;
    transform: translate(0, 50%);
  }

  .scroll-to-top {
    pointer-events: all;

    position: absolute;
    right: 20px;
    bottom: 10%;
  }
}
</style>